
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"100","width":"100","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 91 91"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M79.057 35.039C49.334 32.324 47.119 30.141 44.379.68c-2.744 29.461-4.961 31.645-34.697 34.359C39.418 37.74 41.635 39.953 44.379 69.4c2.74-29.447 4.955-31.66 34.678-34.361zM32.119 64.867c-1.047 11.217-1.895 12.055-13.215 13.092 11.32 1.021 12.168 1.879 13.215 13.107 1.029-11.229 1.877-12.086 13.211-13.107-11.334-1.037-12.182-1.875-13.211-13.092zM73.203 60.488c.682-7.289 1.234-7.826 8.594-8.514-7.359-.67-7.912-1.205-8.594-8.496-.676 7.291-1.23 7.826-8.59 8.496 7.36.688 7.914 1.225 8.59 8.514z"}})])
          )
        }
      }
    